import React from "react";
import HeroImg from "../../Assets/heroImg.png";
import ModalClick from "./ModalClick";
// import { Modal, Button } from 'react-bootstrap';

const HeroText = {
  maxWidth: 680,
};

const HeroStyle = {
  position: "absolute",
  top: "25%",
};

const Hero = () => {
  return (
    <div className="position-relative">
      <img
        style={{ width: "100%", objectFit: "cover", height: "45rem" }}
        src={HeroImg}
        loading="lazy"
        alt="logo"
      />
      <div className="position-absolute top-0 start-0 w-100 bg-dark h-100 opacity-50"></div>

      <div
        className="position-absolute text-center text-white w-100 my-lg-4"
        style={HeroStyle}
      >
        <h1
          className="text-capitalize display-5 lh-4 w-100 mx-auto fw-bolder px-2 px-md-0 mb-4"
          style={HeroText}
        >
          We Make logistics seamless for you
        </h1>
        <p className="mx-auto lead px-2 px-md-0" style={HeroText}>
          At Logistat, we provide a robust enterprise system for small and large
          scale delivery companies to manage their operations affodably and
          enter the market with a competitive edge.
        </p>
        {/* Request a Demo */}
        <span
          className="btn btn-lg text-white my-4 py-2 px-4 border-0"
          style={{ background: "rgba(40, 182, 114, 1)" }}
        >
          <ModalClick text="Request a Demo" />
        </span>
      </div>
    </div>
  );
};

export default Hero;
